import React from 'react';
import {Header,Footer, ReturnPolicy} from '../components/components'

const RefundPolicy = () => {
  return (
    <>
    <Header/>
    <ReturnPolicy/>
    <Footer/>
    </>
  );
};

export default RefundPolicy;